// Dev-only logger — no-ops in production builds so debug output never ships to users.
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};

export default logger;
